/**
 * Security headers must be sent by the HTTP layer.
 *
 * Injecting them from the SPA is unreliable and, for several headers, invalid.
 * The previous Helmet-based implementation also blocked Auth0 assets on the
 * hosted dev dashboard. Keep this component as a no-op so App usage does not
 * need to change while headers remain owned by CloudFront / hosting.
 */
const SecurityHeaders = () => null;

export default SecurityHeaders;
